import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import nl from "./nl.json";
import en from "./en.json";
import hu from "./hu.json";

export const SUPPORTED = ["nl", "en", "hu"];
export const DEFAULT_LNG = "nl";

// Read language from URL first path segment (/nl /en /hu). Fall back to browser detector.
function pathLng() {
  if (typeof window === "undefined") return null;
  const seg = window.location.pathname.split("/").filter(Boolean)[0];
  return SUPPORTED.includes(seg) ? seg : null;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      nl: { translation: nl },
      en: { translation: en },
      hu: { translation: hu },
    },
    lng: pathLng() || undefined,
    fallbackLng: DEFAULT_LNG,
    supportedLngs: SUPPORTED,
    interpolation: { escapeValue: false },
    detection: {
      // Detect language ONLY from the URL prefix (/en, /hu) or the user's
      // explicit previous choice (localStorage). We intentionally do NOT read
      // navigator/browser language, so first-time visitors always see Dutch —
      // the default site language — regardless of their browser settings.
      order: ["path", "localStorage"],
      lookupFromPathIndex: 0,
      caches: ["localStorage"],
    },
  });

export default i18n;
